import {createBrowserRouter} from "react-router-dom";
import AppLayout from './layouts/AppLayout.jsx';
import Dashboard from './pages/app/Dashboard.jsx';
import Error404 from './pages/Error404.jsx';
import ProjectEdit from './pages/app/ProjectEdit.jsx';
import AuthLayout from './layouts/AuthLayout.jsx';
import Login from './pages/auth/Login.jsx';
import Register from './pages/auth/Register.jsx';
import ForgotPassword from './pages/auth/ForgotPassword.jsx';
import UserBase from './pages/user/UserBase.jsx';
import ResetPassword from './pages/auth/ResetPassword.jsx';
import Voices from './pages/app/Voices.jsx';
import MyVoices from './pages/app/MyVoices.jsx';
import AccountVerification from './pages/auth/AccountVerification.jsx';
import TextToSpeech from './pages/app/TextToSpeech.jsx';
import PrivacyPolicy from './pages/privacyPolicy.jsx';
import VoiceCloning from "./pages/app/VoiceCloning.jsx";
import ContactUsPage from "./pages/user/ContactUs.jsx";
import AutoDubLanding from "./pages/autoDub/AutoDubLanding.jsx";
import AutoDubBuilder from "./pages/autoDub/AutoDubBuilder.jsx";
import AutoDubDetail from "./pages/autoDub/AutoDubDetail.jsx";
import ChannelsPage from "./pages/autoDub/ChannelsPage.jsx";

const routes = createBrowserRouter([
	{
		path: "/",
		element: <AuthLayout/>,
		children: [
			{
				path: "",
				element: <Login/>,
			},
			{
				path: "login",
				element: <Login/>,
			},
			{
				path: "register",
				element: <Register/>,
			},
			{
				path: "forgot-password",
				element: <ForgotPassword/>,
			},
			{
				path: "auth/reset-password/:token",
				element: <ResetPassword/>,
			},
			{
				path: "account-verify/:token",
				element: <AccountVerification/>,
			},
		]
	},
	{
		element: <AppLayout/>,
		children: [
			{
				path: "/app",
				children: [
					{
						path: "",
						element: <Dashboard/>,
					},
					{
						path: "voices",
						element: <Voices/>,
					},
					{
						path: "my-voices",
						element: <MyVoices/>,
					},
					{
						path: "text-to-speech",
						element: <TextToSpeech/>,
					},
					{
						path: ":ID/edit",
						element: <ProjectEdit/>
					}
				]
			},
			{
				path: "voices",
				element: <Voices/>,
			},
			{
				path: "my-voices",
				element: <MyVoices/>,
			},
			{
				path: "text-to-speech",
				element: <TextToSpeech/>,
			},
			{
				path: "/user/:pageName",
				element: <UserBase/>,
			},
			{
				path: "/user/:pageName/:token",
				element: <UserBase/>,
			},
			{
				path: "/voices-cloning",
				element: <VoiceCloning/>,
			},
			{
				path: "/auto-dub",
				children: [
					{
						path: "",
						element: <AutoDubLanding/>,
					},
					{
						path: "create",
						element: <AutoDubBuilder/>,
					},
					{
						path: ":id",
						element: <AutoDubDetail/>,
					},
					{
						path: ":id/edit",
						element: <AutoDubBuilder/>,
					},
					{
						path: ":id/duplicate",
						element: <AutoDubBuilder/>,
					},
				]
			},
			{
				path: "/channels",
				element: <ChannelsPage/>,
			},
		]
	},
	{
		path: "privacy-policy",
		element: <PrivacyPolicy/>
	},
	{
		path: "*",
		element: <Error404/>
	},
	{
		path: "/contact-us",
		element: <ContactUsPage/>,
	},
]);
export default routes;
